module.exports = "<div style=\"text-align: center;height:100%;\">\r\n    <img style=\"position: absolute;top:50%;left:50%;margin-top: -200px;margin-left: -150px;\" src=\"/public/images/error.jpg\"/>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/appError.html
// module id = 203
// module chunks = 0